import Cookies from 'js-cookie';
import { PREFIX } from '@/config/constants';
export const setCookie = (name, val, expires = 30) => {
  Cookies.set(PREFIX.COOKIE + name, val, {
    path: '/',
    expires
  });
};
export const getCookie = name => Cookies.get(PREFIX.COOKIE + name);
export const removeCookie = name => {
  Cookies.remove(PREFIX.COOKIE + name);
};
export const removeAllCookies = () => {
  const regex = /^b2b-official/;
  Object.keys(Cookies.get()).filter(item => regex.test(item)).forEach(cookieName => {
    const neededAttributes = {
      path: '/',
      expires: 30
    };
    Cookies.remove(cookieName, neededAttributes);
  });
};
export const setSession = (name, val) => {
  sessionStorage.setItem(PREFIX.SESSION + name, val);
};
export const getSession = name => sessionStorage.getItem(PREFIX.SESSION + name);
export const removeSession = name => {
  sessionStorage.removeItem(PREFIX.SESSION + name);
};
export const removeAllSession = () => {
  sessionStorage.clear();
};
export const removeAll = () => {
  removeAllCookies();
  removeAllSession();
};